(() => {
	angular
		.module('main')
		.controller('ForgotPasswordController', ForgotPasswordController);

	ForgotPasswordController.$inject = [
		'$scope',
		'$rootScope',
		'$location',
		'$http',
		'stringModifierService',
		'messageService'
	];

	function ForgotPasswordController(
		$scope,
		$rootScope,
		$location,
		$http,
		stringModifierService,
		messageService
	) {
		$rootScope.navbarSignUp = false;
		$rootScope.navbarSignIn = false;
		const email = $scope.email;

		const request = {
			forgot(email, forgotSuccessCallback, forgotErrorCallback) {
				$http({
					method: 'POST',
					url: '/public/rest/user/forgotpassword',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					},
					transformRequest: stringModifierService.urlEncodDataTransform,
					data: {
						email
					}
				}).then(
					({ data, status }) => {
						console.log(`status ${status}`);
						forgotSuccessCallback(data);
					},
					() => forgotErrorCallback()
				);
			}
		};

		const forgotSuccessCallback = function(data) {
			$scope.userActionResult = data;
			$scope.button_disable = false;
			if (data) {
				if (data.success) {
					messageService.showToaster('s_0', 'forgotPassword');
					delete $rootScope.error;
					$location.path('/login');
				} else {
					toastr.error(data.message, 'Error');
					console.log(`data failed forgot : ${data}`);
				}
				console.log(data);
			}
		};

		function forgotErrorCallback() {
			toastr.error('Failed request to server', 'Error');
			$scope.button_disable = false;
		}

		$scope.forgot = function(email) {
			delete $rootScope.error;
			toastr.clear();
			$scope.button_disable = true;
			console.log(`Forgot called + ${email}`);
			request.forgot(email, forgotSuccessCallback, forgotErrorCallback);
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/login/forgotPasswordController.js